RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.FieldEditor = Marionette.ItemView.extend({
        template: '#adminCompanyFieldEditorTemplate',

        ui: {
            companyName: '#inputSiteName'
        },

        events: {
            'change @ui.companyName': 'onCompanyNameChange'
        },

        onCompanyNameChange: function () {
            const me = this;
            me.model.set({
                name: me.ui.companyName.val()
            });
        }
    });
});
